<fieldset>
  <div class="form-group" [class.row]="!detailViewComponent.smallScreen">
    <label
      class="col-form-label"
      [class.col-5]="!detailViewComponent.smallScreen"
      [class.text-right]="!detailViewComponent.smallScreen"
      [class.required]="prop.field_required"
    >
      {{ prop.field_label | translate }}
    </label>
    <div [class.col-7]="!detailViewComponent.smallScreen">
      <!-- Single text field -->

      <div class="input-group input-group-sm" [class.required-field-border]="prop.field_required">
        <input
          *ngIf="!prop.field_multi"
          #inputFieldRef
          autocomplete="off"
          type="text"
          class="form-control"
          [class.disabled-color]="!prop.field_editable"
          [id]="prop.field_id"
          [name]="prop.field_name"
          [readonly]="!prop.field_editable"
          [formControl]="graphicFormGroup.controls[prop.field_name]"
          (change)="onChangeLineNummber($event)"
        />
        <div
          *ngIf="prop.field_required"
          class="input-group-append required-field-block required-field-border"
        >
          <span class="input-group-text" id="basic-addon1">*</span>
        </div>
        <error-tooltip [errorMessages]="errorMessages"></error-tooltip>
      </div>

      <!-- Text area -->
      <textarea
        *ngIf="prop.field_multi"  #inputAreaRef
        class="form-control"
        [class.is-invalid]="isInvalid"
        rows="3"
        [id]="prop.field_id"
        [name]="prop.field_name"
        [readonly]="!prop.field_editable"
        [formControl]="graphicFormGroup.controls[prop.field_name]"
        [class.required-field-border]="prop.field_required"
      ></textarea>
      <error-tooltip [errorMessages]="errorMessages"></error-tooltip>
    </div>
  </div>
</fieldset>
